import React from "react";

export const PLANTING_PACKAGING_HELP_TITLE = "Sementes por embalagem";

export function PlantingPackagingHelpContent() {
  return (
    <>
      <p>
        Informe o <strong>número inteiro de sementes</strong> em cada
        embalagem que vai para a plantadeira — unidades, não milhões.
      </p>
      <p>
        A embalagem pode ser <strong>bag</strong> ou <strong>saca</strong>. No
        formulário usamos a descrição <strong>bag/sacas</strong> para cobrir os
        dois casos.
      </p>
      <p>
        Exemplo de soja: um bag costuma ter <strong>5.000.000</strong>{" "}
        sementes. Use o ponto de milhar para não confundir mil com milhão.
      </p>
    </>
  );
}
